"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_MESSAGE_CHANNEL = exports.PUBLISHED_SIGNING_MESSAGE_NAME = exports.PUBLISHER_MESSAGE_NAME = exports.CHANNEL_AUTH_AUDIENCE = exports.PRIVATE_CHANNEL_PREFIX = void 0;
exports.PRIVATE_CHANNEL_PREFIX = 'private';
exports.CHANNEL_AUTH_AUDIENCE = 'channel-auth-audience';
exports.PUBLISHER_MESSAGE_NAME = 'events';
exports.PUBLISHED_SIGNING_MESSAGE_NAME = 'sign';
exports.SYSTEM_MESSAGE_CHANNEL = 'system';
